import React from "react";
import useDatos from "../pages/Mostrar/useDatos";
import Carrusel from "../components/Carrusel/Carrusel";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaTrash, FaEdit } from "react-icons/fa";
import "./MostrarInmuebles.css";
import API from "./Fetchs";

const MostrarInmuebles = ({ tipo = "" }) => {
  const url = API.read;
  const { datos: inmuebles = [], loading, error } = useDatos(url); // Evita que 'inmuebles' sea undefined

  const handleEliminar = async (id) => {
    if (!window.confirm("¿Estás seguro de eliminar este inmueble permanentemente?")) return;

    try {
      const response = await fetch(API.delete, {

        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.message || "Error en la eliminación");
      }

      // Recargar la página para actualizar la lista
      window.location.reload();
    } catch (err) {
      console.error("Error en eliminación:", err);
      alert(err.message || "Error al contactar con el servidor");
    }
  };

  if (loading) return <p className="text-center">Cargando propiedades...</p>;
  if (error) return <p className="text-center text-danger">Error: {error.message}</p>;

  // Verificar que inmuebles es un array antes de usar .map()
  const inmueblesFiltrados = Array.isArray(inmuebles) ?
    (tipo ? inmuebles.filter(inmueble => inmueble.tipo_inmueble.toLowerCase() === tipo.toLowerCase()) : inmuebles)
    : [];

  const abrirGoogleMaps = (inmueble) => {
    const latitud = inmueble.latitud;
    const longitud = inmueble.longitud;
    const ubicacion = inmueble.ubicacion;

    if (latitud && longitud) {
      window.open(`https://www.google.com/maps?q=${latitud},${longitud}`, "_blank");
    } else if (ubicacion && ubicacion.trim() !== "") {
      const query = encodeURIComponent(ubicacion);
      window.open(`https://www.google.com/maps/search/?api=1&query=${query}`, "_blank");
    } else {
      alert("Ubicación no disponible para este inmueble.");
    }
  };
  return (
    <div className="container mt-5">
      {inmueblesFiltrados.length === 0 ? (
        <div className="alert alert-info text-center">
          No hay propiedades disponibles en esta categoría
        </div>
      ) : (
        <div className="row g-4">
          {inmueblesFiltrados.map((inmueble) => {
            const baseUrl = `${API.readimg}/${inmueble.id}`;

            const imagenesPortada = [1, 2, 3]
              .map((num) => {
                const imgName = inmueble[`img_portada_${num}`];
                if (!imgName || imgName.toLowerCase() === "null") return null;
                return `${baseUrl}/${imgName}`;
              })
              .filter(Boolean);

            const descripcionCorta = inmueble.descripcion
              ? inmueble.descripcion.length > 50
                ? `${inmueble.descripcion.substring(0, 50)}...`
                : inmueble.descripcion
              : "Descripción no disponible";

            return (
              <div key={inmueble.id} className="col-md-6 col-lg-4" id={inmueble.id}>
                <div className="card h-100 shadow-sm">
                  <div className="card-img-top" style={{ height: "250px", overflow: "hidden" }}>
                    {imagenesPortada.length > 0 ? (
                      <Carrusel
                        images={imagenesPortada}
                        className="h-100"
                        imgStyle={{ objectFit: "cover", height: "100%" }}
                      />
                    ) : (
                      <img
                        src="/default-property.jpg"
                        alt="Imagen no disponible"
                        className="h-100 w-100"
                        style={{ objectFit: "cover" }}
                      />
                    )}
                  </div>

                  <div className="card-body d-flex flex-column">
                    <h3 className="h5 card-title text-primary mb-3">
                      {inmueble.direccion} - {inmueble.lugar}
                    </h3>

                    {/* Mostrar ubicación con función para abrir Google Maps */}
                    {(inmueble.ubicacion || (inmueble.latitud && inmueble.longitud)) && (
                      <div className="mb-2">
                        <button
                          onClick={() => abrirGoogleMaps(inmueble)}
                          className="text-decoration-none btn btn-link"
                        >
                          <FaMapMarkerAlt className="me-2 text-danger" />
                          <span className="text-muted">Ver ubicación en Google Maps</span>
                        </button>
                      </div>
                    )}

                    <p className="card-text mb-3 text-muted">{descripcionCorta}</p>

                    <div className="mt-auto">
                      <div className="d-grid gap-2">
                        <div className="btn-group">
                          <Link to={`/mostrar/${inmueble.id}`} className="btn btn-warning">
                            <FaEdit className="me-2" />
                            Editar
                          </Link>
                          <button onClick={() => handleEliminar(inmueble.id)} className="btn btn-danger">
                            <FaTrash className="me-2" />
                            Eliminar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MostrarInmuebles;
